import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'

import { queryUrl, QUERY_KEY } from '~/client/components/Gallery/Header/Favorites/queryUrl'

type QueryKey = VP.MTT.Queries.Url.UrlQueryKey

export const useQueryUrl = (
  locale: i18n.Locale,
  urlId: string,
  options?: Omit<UseQueryOptions<string, Error, string, QueryKey>, 'queryKey'>,
): UseQueryResult<string, Error> =>
  useQuery<string, Error, string, QueryKey>({
    queryKey: [
      QUERY_KEY,
      {
        locale,
        urlId,
      },
    ],
    queryFn: queryUrl,
    ...options,
  })
